import React, { useEffect, useState } from 'react';
import { Modal } from 'schola-components';
import ClaimFormLanding from '../claim-school/v2/ClaimFormLanding';
import styles from '../landing-page/landing-page.module.scss';

const WebflowPage = ({ params }) => {
  const [showClaimModal, setShowClaimModal] = useState(false);
  const [trigger, setTrigger] = useState('');

  const webflowsite = `https://claim.schola.com/${
    !params.pagename || params.pagename === 'home' ? '' : params.pagename
  }${window.location.search ?? window.location.search}${window.location.hash ?? window.location.hash}`;
  const handleIFrameMessage = (event) => {
    if (event?.data && event.data.action) {
      if (event.data.action === 'openClaimModal') {
        setTrigger(event.data.trigger);
        setShowClaimModal(true);
      }
    }
  };

  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener('message', handleIFrameMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', handleIFrameMessage);
    }
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const renderClaimModal = () => {
    if (showClaimModal) {
      return (
        <Modal
          onClose={() => {
            setShowClaimModal(false);
          }}
          isVisible
          className="claim-modal-v3"
          classNameContent={styles.claimModal}>
          <ClaimFormLanding
            params={params}
            trigger={trigger}
            toggleClaim={() => {
              setShowClaimModal(false);
            }}
            // positionAbsolute={this.setClasses}
          />
        </Modal>
      );
    }
    return null;
  };

  return (
    <>
      <iframe
        id="webflow-container"
        src={webflowsite}
        width="100%"
        style={{
          width: '100%',
          height: '100vh',
        }}
        name="test"
        title="test"
      />
      {renderClaimModal()}
    </>
  );
};

export default WebflowPage;
